import React from "react";
import * as styles from "./ResponsiveImgixImage.module.scss";
import clsx from "clsx";
import { useDebouncedResizeObserver } from "@silversea-ssc/ui-components-react";
import { ImgixImage, ImgixImageProps } from "./ImgixImage";

type ResponsiveImgixImageProps = ImgixImageProps & {
  defaultWidth: number;
  defaultHeight: number;
};

const ResponsiveImgixImageBase: React.FC<
  React.PropsWithChildren<ResponsiveImgixImageProps>
> = ({ className, defaultWidth, defaultHeight, ...props }) => {
  const { ref, width, height } = useDebouncedResizeObserver(1000);
  return (
    <React.Fragment>
      <ImgixImage
        ref={ref}
        {...props}
        className={clsx([styles.responsiveImageContainer, className])}
        width={width || defaultWidth}
        height={height || defaultHeight}
      />
    </React.Fragment>
  );
};

export default React.memo(ResponsiveImgixImageBase);
